<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible"
      width="550px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <div class="item-box">
          <div class="item1">
            <el-form-item label="封面图:" prop="cover">
              <base-upload
                class="upload"
                :cover="params.cover"
                :action="action"
                :wSize="this.wSize"
                :hSize="this.hSize"
                :width="'138.5px'"
                :height="this.height"
                @successCallback="handleAvatarSuccess"
              ></base-upload>
            </el-form-item>
          </div>
          <div class="item2" style="width:300px">
            <el-form-item label="广告类型:" prop="adsType">
              <el-select v-model.number="params.adsType" size="small" placeholder="广告类型" disabled>
                <el-option
                  v-for="item in adsTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标题:" prop="title">
              <el-input v-model="params.title" size="small" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="位置:" prop="position">
              <el-select v-model.number="params.position" size="small" placeholder="位置" clearable>
                <el-option
                  v-for="item in positionList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="跳转方式:" prop="hrefType">
              <el-select v-model.number="params.hrefType" size="small" placeholder="跳转方式">
                <el-option
                  v-for="item in hrefTypeList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="protocol" v-if="params.hrefType!==2">
              <span>提示:地址协议请使用</span>
              <span
                style="color:red"
              >{{this.protocolType=params.hrefType===0?'http或https':'yinselink或yinselinks'}}</span>
            </div>
            <el-form-item label="链接地址:" prop="href">
              <el-select
                v-show="params.hrefType===2 && (params.position!==1 && params.position!==2)"
                v-model.number="params.href"
                size="small"
                placeholder="请选择跳转地址"
                clearable
              >
                <el-option
                  v-for="item in hrefList"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-show="params.hrefType===2 && (params.position===1 || params.position===2)"
                v-model.number="params.href"
                size="small"
                placeholder="请选择跳转地址"
                clearable
              >
                <el-option
                  v-for="item in hrefListTwo"
                  :value="item.value"
                  :label="item.label"
                  :key="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-show="params.hrefType!==2"
                v-model="params.href"
                size="small"
                placeholder="请输入链接地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="排序号:" prop="sortCode">
              <el-input v-model.number="params.sortCode" size="small" placeholder="排序号"></el-input>
            </el-form-item>
            <el-form-item label="备注:" prop="remark">
              <el-input
                v-model="params.remark"
                size="small"
                placeholder="备注"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
              ></el-input>
            </el-form-item>
            <el-form-item label="激活状态:" prop="href">
              <el-switch v-model="params.active"></el-switch>
            </el-form-item>
            <el-form-item label="开始时间:">
              <el-date-picker
                v-model="params.start"
                type="datetime"
                placeholder="选择日期时间"
                :clearable="clearable"
                size="small"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:">
              <el-date-picker
                v-model="params.end"
                type="datetime"
                placeholder="选择日期时间"
                :clearable="clearable"
                size="small"
                width="300px"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import moment from "moment";
import { changeDate } from "@/utils/global";
export default {
  data() {
    return {
      clearable: false,
      protocolType: "", //协议类型
      labelPosition: "left",
      dialogVisible: false,
      title1: "",
      flag: false,
      type: "",
      id: "",
      // 图片上传地址
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      // 新增、编辑表单数据
      params: {
        id: "", //广告id
        reviewID: "", //审核id
        districtCode: "", //商区码
        adsType: 0, //广告类型
        title: "", //广告标题
        cover: "", //广告封面图
        hrefType: 0, //广告跳转类型
        href: "", //广告跳转地址
        position: 0, //广告位置
        sortCode: 0, //排序号
        click: 0, //点击次数
        remark: "", //备注
        active: true, //激活状态 true:激活
        createdAt: "", //创建时间
        start: "",
        end: "",
      },
      hrefTypeList: [
        { label: "外部浏览器跳转", value: 0 },
        { label: "内部浏览器跳转", value: 1 },
        { label: "APP内部跳转", value: 2 },
      ],
      hrefList: [
        { label: "个性名片(推广界面)", value: "yinseinner://personal_card/" },
        { label: "VIP界面", value: "yinseinner://vip_page/" },
        { label: "钱包界面", value: "yinseinner://wallet_page/" },
        { label: "全民代理", value: "yinseinner://universal_agent/" },
      ],
      hrefListTwo: [
        { label: "个性名片(推广界面)", value: "yinseinner://personal_card/" },
        { label: "VIP界面", value: "yinseinner://vip_page/" },
        { label: "钱包界面", value: "yinseinner://wallet_page/" },
        { label: "全民代理", value: "yinseinner://universal_agent/" },
        { label: "撩吧", value: "yinseinner://page_home_post/" },
      ],
      adsTypeList: [
        { label: "系统广告", value: 0 },
        { label: "商区广告", value: 1 },
      ],
      positionList: [
        { label: "启动页广告", value: 0 },
        { label: "首页-推荐小广告", value: 1 },
        { label: "首页-弹窗公告", value: 2 },
        { label: "消息-界面广告", value: 3 },
        { label: "撩吧-轮播广告", value: 4 },
        { label: "钱包-轮播广告", value: 5 },
        { label: "搜索-轮播广告", value: 6 },
        { label: "AV解说-轮播广告", value: 7 },
        { label: "签到-轮播广告", value: 8 },
      ],
      // 表单验证规则
      rules: {
        id: [{ required: true, message: "请输入ID", trigger: "blur" }],
        discCode: [
          { required: true, message: "请输入商区码", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],

        cover: [{ required: true, message: "请输入封面图", trigger: "blur" }],
        hrefType: [
          { required: true, message: "请选择链接类型", trigger: "blur" },
          // { validator: this.urlhrefType, trigger: "change" }
        ],
        href: [
          { message: "请输入正确的Url", trigger: "blur" },
          { validator: this.urlSchemes, trigger: "blur" },
        ],
        position: [{ required: true, message: "请选择位置", trigger: "blur" }],
        sortCode: [
          { required: true, message: "请输入排序号", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    discCode() {
      const discCode = this.$store.state.loginModule.userInfo.code;
      return discCode.toString();
    },
    wSize() {
      const wSize =
        this.params.position === 0 ||
        this.params.position === 3 ||
        this.params.position === 4 ||
        this.params.position === 5
          ? "720"
          : this.params.position === 1
          ? "560"
          : "656";
      return wSize.toString();
    },
    hSize() {
      const wSize =
        this.params.position === 0
          ? "1560"
          : this.params.position === 1
          ? "620"
          : this.params.position === 2
          ? "1300"
          : this.params.position === 4
          ? "500"
          : this.params.position === 3
          ? "260"
          : this.params.position === 7
          ? "500"
          : "120";
      return wSize.toString();
    },
    height() {
      const wSize =
        this.params.position === 0
          ? "300px"
          : this.params.position === 1
          ? "153.5px"
          : this.params.position === 2
          ? "274.5px"
          : this.params.position === 4
          ? "96.2px"
          : this.params.position === 3
          ? "50px"
          : this.params.position === 7
          ? "96.2px"
          : "23.1px";
      return wSize.toString();
    },
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.type === "edit" ? this.editAds() : this.addAds();
        } else {
          return false;
        }
      });
    },
    changeTime(string) {
      // 时间字符传 2019/10/01T12:00:00+08:00(后面时区固定为+08:00)
      let time = moment(string).format();
      let newTime = time.slice(0, 19) + "+08:00";
      return newTime;
    },
    // 添加标签
    addAds() {
      let params = Object.assign({}, this.params, {
        href: this.params.href ? this.params.href : "ZERO_VALUE",
        start: this.changeTime(this.params.start),
        end: this.changeTime(this.params.end),
      });
      API.addAds(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else if (res.code === 9200) {
            this.$message.error("新增版本号低于当前最新版本");
          } else {
            this.$message.error(res.tip ? res.tip : "添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    editAds() {
      let params = Object.assign({}, this.params, {
        href: this.params.href ? this.params.href : "ZERO_VALUE",
        start: this.changeTime(this.params.start),
        end: this.changeTime(this.params.end),
      });
      API.editAds(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            this.$message.error(res.tip ? res.tip : "编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    handleAvatarSuccess(res) {
      this.params.cover = res.data.coverImg;
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.type === "add" ? this.$refs.form.resetFields() : "";
      this.params = {
        id: "", //广告id
        reviewID: "", //审核id
        districtCode: "", //商区码
        adsType: 0, //广告类型
        title: "", //广告标题
        cover: "", //广告封面图
        hrefType: 0, //广告跳转类型
        href: "", //广告跳转地址
        position: 0, //广告位置
        sortCode: 0, //排序号
        click: 0, //点击次数
        remark: "", //备注
        active: false, //激活状态 true:激活
        createdAt: "", //创建时间
        start: "",
        end: "",
      };
      this.$emit("handlerAgentList");
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title1 = "编辑广告";
        {
          this.params = data;
        }
        this.params.start = changeDate(data.start);
        this.params.end = changeDate(data.end);
      } else {
        this.title1 = "新增广告";
      }
    },
    //url地址验证
    urlSchemes(rule, value, callback) {
      let reg;
      switch (this.params.hrefType) {
        case 0:
          reg = /(http|https):\/\/([\w.]+\/?)\S*/gi;
          break;
        case 1:
          reg = /(yinselink|yinselinks):\/\/([\w.]+\/?)\S*/gi;
          break;
        case 2:
          reg = /yinseinner:\/\/([\w.]+\/?)\S*/gi;
          break;
      }
      if (reg.test(value) || !value) {
        callback();
      } else {
        callback(new Error("请输入有效地址"));
      }
    },
    urlhrefType(rule, value, callback) {
      let err = undefined;
      let reg;
      if (this.params.href !== "") {
        switch (value) {
          case 0:
            reg = /(http|https):\/\/([\w.]+\/?)\S*/gi;
            break;
          case 1:
            reg = /(yinselink|yinselinks):\/\/([\w.]+\/?)\S*/gi;
            break;
          case 2:
            reg = /yinseinner:\/\/([\w.]+\/?)\S*/gi;
            break;
        }
        if (!reg.test(this.params.href)) {
          switch (value) {
            case 0:
              err = new Error("请使用 http或https 协议");
              break;
            case 1:
              err = new Error("请使用 yinselink或yinselinks 协议");
              break;
            case 2:
              err = new Error("请选择跳转链接");
              break;
            default:
              err = new Error("URL格式不正确");
          }
        }
      }
      callback(err);
    },
  },
};
</script>

<style lang="scss" >
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
      .protocol {
        font-size: 10px;
        margin-left: 10px;
        color: green;
        // position: relative;
        // top: 170px;
        // left: 10px;
      }
    }
  }
}
</style>
